export const AboutSectionData = [
    {
        id: "city_walking_tour",
        CarouselList : [
            {
                src: "./photos/city_walking_tour/1.jpg"
            },
            {
                src: "./photos/city_walking_tour/2.jpg"
            },
            {
                src: "./photos/city_walking_tour/3.jpg"
            },
            {
                src: "./photos/city_walking_tour/4.jpg"
            },
        ],
        boldText: "CITY WALKING TOUR GIVES YOU A OPPORTUNITY OF A REAL EXPERIENCE TO THE LIFE OF PUSHKAR. HERE YOU CAN EXPLORE SPIRITUALITY, CULTURAL PRACTICES, TRADITIONS, BUSTLING BEAUTIFUL MARKETS, TEMPLES, ARCHITECTURE AND HISTORICAL PLACES.",
        description: "Join us on completely unique and offbeat experience of Pushkar. Here we can explore the world's only one iconic Brahma temple, Pushkar lake, Old Vishnu temple, Varaha temple, Spiritual walk with the highlights of lake and market."

    },
    {
        id: "evening_walking_tour",
        CarouselList : [
            {
                src: "./photos/evening_walking_tour/1.jpg"
            },
            {
                src: "./photos/evening_walking_tour/2.jpg"
            },
            {
                src: "./photos/evening_walking_tour/3.jpg"
            },
            {
                src: "./photos/evening_walking_tour/4.jpg"
            },
        ],
        boldText: "PUSHKAR IS A BEAUTIFUL TOWN DURING THE DAY YET IT IS EVEN MORE BEAUTIFUL IN THE EVENING. COME AND JOIN US ON THIS UNIQUE AND COMPLETELY OFFBEAT EXPERIENCE OF PUSHKAR IN EVENING...",
        description: "Join this Evening Walking Tour to explore a different side of the town. Visit local popular hangouts places, Sunset Point, Evening Aarti Ceremonies, A Spiritual walk around the lake which covers 52 Ghats and 500 temples, Walk the streets of Pushkar when they are prettiest at Night..."
    },
    {
        id: "half_day_tour",
        CarouselList : [
            {
                src: "./photos/half_day_tour/1.jpg"
            },
            {
                src: "./photos/half_day_tour/2.jpg"
            },
            {
                src: "./photos/half_day_tour/3.jpg"
            }
        ],
        boldText: "JEXCURSIONS TO EXPLORE MOST EXCITING SIDE OF PUSHKAR INCLUDING THE RURAL CULTURE OF PUSHKAR WITH BEAUTIFUL TEMPLES ON THE FOOTHILLS OF ARAVALI MOUNTAINS,ROSE FIELDS ON THIS HALF DAY SIGHTSEEING TOUR .",
        description: "Go beyond the typical tourist sights in Pushkar learn about life in rural India during this half-day tour. Travel with your private tour guide to the beautiful temple on foothills of Aravali mountains and ashrams,Deer park. Learn about the daily life of a villager, see local industries like pottery making, manufacturing of rose and gooseberry industry, cultivation, visit a village school, and learn to cook the local cuisine."
    },
    {
        id: "camel_safari_jeep_safari_and_quad_biking",
        CarouselList : [
            {
                src: "./photos/camel_safari/1.jpg"
            },
            {
                src: "./photos/camel_safari/2.jpg"
            },
            {
                src: "./photos/camel_safari/3.jpg"
            }
        ],
        boldText: "THE PUSHKAR ROUTE OFFERS A VARIETY OF SAFARI AND ADVENTURE PACKAGES IN AFFORDABLE AND RELIABLE IN PRICES.",
        description: "The Pushkar Route offers camel safaris, camel carts, Jeep Safari, horse riding, Polaris ATV bike and desert experience packages as well as Customised trips to suite your personal desires. From a few hours to several days the opportunities are endless."
    },

]